import type { LegislativePriorityType, LegislativeStanceType } from "@/types/djangio"

export const getIdFromUri = (uri: string) => {
    const splitUri: string[] = uri.split("/")
    return splitUri[splitUri.length - 2]
}

export const getStanceOptions = (stancesWithCustomLabels: LegislativeStanceType[]) => {
    const formattedStanceOptions = stancesWithCustomLabels
        .filter((stance) => stance.value)
        .map((stance) => ({
            label: stance.label,
            value: String(stance.value),
            icon: stance.fa5_icon as string,
        }))

    return [...formattedStanceOptions].sort(DjangIO.valueSort)
}

export const getPriorityOptions = () => {
    const priorityOptions = DjangIO.app.userdata.types.LegislativePriorityType.items() as LegislativePriorityType[]

    return priorityOptions
        .filter((priority) => priority.value)
        .map((priority) => ({
            label: priority.label.split(" ")[0],
            value: String(priority.value),
            icon: priority.fa5_icon,
        }))
}
